import '@fontsource/roboto-serif'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { CssBaseline } from '@mui/material'
import { LicenseInfo } from '@mui/x-license'
import { PostHogProvider } from 'posthog-js/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from 'shared/state'
import App from './App'
import './index.scss'
import reportWebVitals from './reportWebVitals'

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE || '')

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
    <React.StrictMode>
        <PostHogProvider
            apiKey={process.env.REACT_APP_POSTHOG_API_KEY || ''}
            options={{
                api_host: process.env.REACT_APP_POSTHOG_HOST,
                defaults: '2025-05-24',
                before_send: (event) => {
                    const exceptionValues: string[] =
                        event?.properties?.$exception_values ?? []
                    if (
                        exceptionValues.some((v) =>
                            v.includes('ResizeObserver loop')
                        )
                    )
                        return null
                    return event
                },
            }}
        >
            <Provider store={store}>
                <CssBaseline />
                <App />
            </Provider>
        </PostHogProvider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
